<template>
    <div>
      <nav-breadcrumb :menu="[{label: userId ? '编辑核心企业账号' : '新增核心企业账号'}]"/>
      <form-build
        form-name="form"
        :form-columns="formColumns"
        :form-rules="formRules"
        :form-data="form"
        :form-buttons="formButtons"
      ></form-build>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'

  export default {
    name: "ConfigDebtorUserEdit",
    data() {
      return {
        debtorListOptions: [],
        form: {
          c__customerId: '',
          u__userId: '',
          u__userCode: '',
          u__userName: '',
          u__telephone: '',
          u__email: '',
          u__password: '',
          u__passwordExpiryDate: '',
          u__passwordExpiryDate__dateformat: '',
          u__disabled: 'N'

        },
        formButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler:$refs=>{
              this.onSubmit($refs)
            }
          },
          {
            label: '取消',
            // type: 'primary',
            clickHandler: $refs=>{
              this.$router.back()
            }
          }
        ],
        userId: this.$route.query['u.userId']||''
      }
    },
    computed: {
      formColumns: function () {
        return [
          {
            label: '用户名',
            component: 'el-input',
            field: 'u__userCode'
          },
          {
            label: '企业名称',
            component: 'el-select',
            field: 'c__customerId',
            options: this.debtorListOptions
          },
          {
            label: '姓名',
            component: 'el-input',
            field: 'u__userName'
          },
          {
            label: '密码',
            component: 'el-input',
            field: 'u__password',
            placeholder: this.userId ? '留空则不修改密码' : '初始登录密码'
          },
          {
            label: '手机号',
            component: 'el-input',
            field: 'u__telephone'
          },
          {
            label: '邮箱',
            component: 'el-input',
            field: 'u__email'
          },
          {
            label: '状态',
            component: 'el-select',
            field: 'u__disabled',
            options: [
              {
                label: '启用',
                value: 'N'
              },
              {
                label: '禁用',
                value: 'Y'
              }
            ]
          }
        ]
      },
      formRules() {
        return this.userId ?
          {
          c__customerId: [
            {
              required: true,
              message: '此项目必填！'
            }
          ],
          u__userName: [
            {
              required: true,
              message: '此项目必填！'
            }
          ],
          u__userCode: [
            {
              required: true,
              message: '此项目必填！'
            }
          ],
        }
        :
          {
            c__customerId: [
              {
                required: true,
                message: '此项目必填！'
              }
            ],
            u__userName: [
              {
                required: true,
                message: '此项目必填！'
              }
            ],
            u__userCode: [
              {
                required: true,
                message: '此项目必填！'
              }
            ],
            u__password: [
              {
                required: true,
                message: '此项目必填！'
              }
            ]
          }
      }
    },
    mounted() {
      this.getDebtorList()

      if( this.userId ) {
        this.getDebtorUserDetail( this.userId )
      }
    },
    watch: {
      $route: function () {
        this.$route.query['u.userId']||''
        this.form= {
          c__customerId: '',
            u__userId: '',
            u__userCode: '',
            u__userName: '',
            u__telephone: '',
            u__email: '',
            u__password: '',
            u__passwordExpiryDate: '',
            u__passwordExpiryDate__dateformat: '',
            u__disabled: 'N'

        }
      }
    },
    methods: {
      onSubmit: function ($refs) {
        $refs.validate(valid=> {
          if(valid) {
            xhr.updateDebtorUser(this.form, res=> {
              try{
                if(res.data.status == 'success') {
                  let userId = res.data.rflag['u.userId']
                  $refs.resetFields()
                  this.$router.push({
                    name: 'CustomerAdminDebtorUserList'
                  })
                }
              }catch(e){}
            })
          }
        })
      },
      getDebtorUserDetail: function (userId) {
        xhr.getDebtorUserList(
          {
            'xlist.search.u.userId': userId,
            'xlist.search.u.userId.op': 'eq'
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.form = res.data.data.shift()
              }
            }catch (e) {

            }
          }
        )
      },
      getDebtorList: function () {
        xhr.getDebtorList({}, res=> {
          try {
            if(res.data.status == 'success' && res.data.data) {
              this.debtorListOptions = res.data.data.map(item=>{
                return {
                  label: item.c__customerName,
                  value: item.c__customerId
                }
              })
            }
          }catch (e) {

          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/DebtorUserEdit.vue